import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Button, Form, InputGroup  } from "react-bootstrap";
import axios from "axios";
import { BASE_URL } from "../../../constants";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../../CommonCSS/SocietyCSS.css";
import Select from 'react-select';
import EditJV_VchrModal from './EditJV_VchrModal';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const FinPaymentVoucher = () => {
  const [isEditable, setIsEditable] = useState(false);

  const [totDrAmt, setTotDrAmt] = useState("");
  const [totCrAmt, setTotCrAmt] = useState("");
  const [totAmtDiff, setTotAmtDiff] = useState("");
  const [isEditMode, setIsEditMode] = useState(true);
  
  // Header data
  const [headerData, setHeaderData] = useState({
    fin_year1: "",
    trans_type: "JV",
    vchr_no: "",
    vchr_date: new Date().toISOString().split("T")[0],
    sect_id: "",
    // cc_id: "",
    // bgt_id: "",
  });

  // Dropdown data
  const [dropdowns, setDropdowns] = useState({
    commonList: [],
  });

  const [ddlSections, setDdlSections] = useState([]);

  const [acctCodes, setAcctCodes] = useState([]);

  // Table rows
  const [detailRows, setDetailRows] = useState([
    { acct_code: "", amount: "", drcr: "DR", narration: "" },
  ]);

  const [showsearchModal, setShowSearchModal] = useState(false);

  // Fetch dropdown lists
  useEffect(() => {
    const fetchDropdowns = async () => {
      try {
        const [AcctRes, SectionRes] =
          await Promise.all([
            axios.get(`${BASE_URL}/api/ddl_Accnt_Mast`),
            axios.get(`${BASE_URL}/api/ddl_sections`),
            //axios.get(`${BASE_URL}/api/ddl_common_master`),
          ]);

        setAcctCodes(AcctRes.data);
        setDdlSections(SectionRes.data);

        // setDropdowns({
        //   commonList: CommonRes.data,
        // });

      } catch (err) {
        console.error("Dropdown fetch error:", err);
      }
    };

    fetchDropdowns();
  }, []);

  // 🔹 Format helper (remove commas etc.)
  const parseNumber = (val) => {
    if (!val) return 0;
    return parseFloat(val.toString().replace(/,/g, "")) || 0;
  };

  // 🔹 Recalculate totals whenever details or header change
  useEffect(() => { // to Calculate Total Dr/Cr amounts

    let debitTotal = 0;
    let creditTotal = 0;
    let diffAmt = 0;

    detailRows.forEach((row) => {
      const amt = parseNumber(row.amount);
      if (row.drcr === "DR") debitTotal += amt;
      else creditTotal += amt;
    });

    diffAmt = debitTotal - creditTotal;

    const formatIndian = (num) =>
      num.toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

    setTotDrAmt(formatIndian(debitTotal));
    setTotCrAmt(formatIndian(creditTotal));
    setTotAmtDiff(formatIndian(diffAmt));

  }, [detailRows, headerData.hdr_amt]);

  const options = acctCodes.map(code => ({
    value: String(code.acct_code),
    label: code.acct_name
  })) || [];

  // Handle input change for header
  const handleHeaderChange = (e) => {
    const { name, value } = e.target;
    setHeaderData((prev) => ({ ...prev, [name]: value }));

  };

  // Handle detail row change
  const handleDetailChange = (index, e) => {

    let { name, value } = e.target;

    if (name === 'amount') {
      value = value.replace(/,/g, "");
      // Allow only digits and at most one decimal point
      if (!/^\d*\.?\d*$/.test(value)) {
        return; // Ignore invalid input
      }
    }

    const updated = [...detailRows];
    updated[index][name] = value;
    setDetailRows(updated);

  };

  const handleDtlAmtBlur = (index, e) => {

    const { name, value } = e.target;

    if (value === "") return;

    // ✅ Convert to number and truncate instead of round
    let numericValue = parseFloat(value);
    if (isNaN(value)) return;

    // Truncate to two decimals (no rounding)
    numericValue = Math.trunc(numericValue * 100) / 100;

    const formatted = new Intl.NumberFormat("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(parseFloat(numericValue));

    const updated = [...detailRows];
    updated[index][name] = formatted;
    setDetailRows(updated);

  };

  const handleAccntChange = (index, selectedOption) => {
    const updated = [...detailRows];
    updated[index].acct_code = selectedOption ? selectedOption.value : "";
    updated[index].acct_name = selectedOption ? selectedOption.label : "";
    setDetailRows(updated);
  };


  // Add new row
  const addRow = () => {
    setDetailRows([...detailRows, { acct_code: "", amount: "", drcr: "CR", narration: "" }]);
  };

  // Remove a detail row
  const removeRow = (index) => {
    const updated = [...detailRows];
    updated.splice(index, 1);
    setDetailRows(updated);
  };

  // Handle button actions
  const handleNew = () => {
    resetPage();
    setIsEditable(true);
    setIsEditMode(false);
  };

  const resetPage = () => {
    
    setHeaderData({
      fin_year1: "",
      trans_type: "JV",
      vchr_no: "",
      vchr_date: new Date().toISOString().split("T")[0],
      // cc_id: "",
      // bgt_id: "",
      sect_id: "",
    });
    setDetailRows([{ acct_code: "", amount: "", drcr: "DR", narration: "" }]);
    setIsEditMode(true);
  }

  const handleClear = () => {
    if (window.confirm("Sure you want to clear all data ?")) {
      resetPage();
      setIsEditable(false);
    }
  };

  const handleSave = async () => {

    if (!headerData.vchr_date || headerData.vchr_date === '') {
      toast.error('Please enter Voucher Date.');
      return;
    }

    if (!headerData.sect_id || headerData.sect_id === '') {
      toast.error('Please select Section.');
      return;
    }

    let lv_err_msg = '';

    for (let i = 0; i < detailRows.length; i++) {
      
        if (!detailRows[i].acct_code || detailRows[i].acct_code === '' )
        {
          lv_err_msg = 'Please select Account at Row # ' + (i + 1);
          break;
        }

        if (!detailRows[i].amount || detailRows[i].amount === '0' )
        {
          lv_err_msg = 'Please enter Amount at Row # ' + (i + 1);
          break;
        }

        if (!detailRows[i].narration || detailRows[i].narration === '0' )
        {
          lv_err_msg = 'Please enter Narration at Row # ' + (i + 1);
          break;
        }

    }

    if (lv_err_msg) {
      toast.error(lv_err_msg);
      return;
    }

    let lv_dupl = 0;

    for (let i = 0; i < detailRows.length; i++) {

      for (let j = i + 1; j < detailRows.length; j++) {

        if (detailRows[i].acct_code === detailRows[j].acct_code) {
          lv_dupl = j;
          break;
        }
      }
      if (lv_dupl > 0) {
        break;
      }
    }

    if (lv_dupl > 0) {
       toast.error('Duplicate Account/Ledger selected at Row # ' + (lv_dupl + 1));
       return;
    }

    if ((parseNumber(totCrAmt) - parseNumber(totDrAmt)) !== 0) {
      toast.error('Debit and Credit Amounts are not tallying.');
      return;
    }

    const response = await axios.get(`${BASE_URL}/api/validate_vchr_date`, { 
      params: { p_VchrDate: headerData.vchr_date, p_Sect_Id: headerData.sect_id }, });

    if (response.data[0].fin_status === 'CLOSED' || response.data[0].fin_status === 'FISCAL') {
      toast.error('Voucher cannot be made in Closed or Fiscal year. Please check the Voucher Date.');
      return;
    }

    const isConfirmed = window.confirm("Sure you want to save this record?");
    if (!isConfirmed) return;

    const payload = {
      header: headerData,
      details: detailRows,
    };

    try {
      const response = await axios.post(`${BASE_URL}/api/save_JournalVoucher`, payload);
      if (response.data.message !== '0') {
        toast.success(`Vocuher No ` + response.data.message + ` saved successfully`);
        setIsEditable(false);
        resetPage();
      }
    } catch (err) {
      console.error("Save error:", err);
      toast.error("Failed to save Voucher. Please check input!");
    }
  };

  const handleVchrRowSelect = async (selRow) => {

    setShowSearchModal(false);

    const response = await axios.get(`${BASE_URL}/api/get_Vchr_ById`, {
            params: {p_Sect_Id: selRow.sect_id, p_FinYear1: selRow.fin_year1, p_VchrNo: selRow.vchr_no, p_TransType: 'JV'},
          });

    headerData.vchr_no = selRow.vchr_no;
    headerData.trans_type = 'JV';
    headerData.fin_year1 = selRow.fin_year1;
    headerData.vchr_date = response.data[0].vchr_date;
    headerData.sect_id = response.data[0].sect_id;
    // headerData.cc_id = response.data[0].cc_id;
    // headerData.bgt_id = response.data[0].bgt_id;

    const detailRows = response.data.filter(row => Number(row.acct_code) > 0);

    if (detailRows.length > 0) {
      setDetailRows(detailRows);
    }

    for (let i = 0; i < detailRows.length; i++) {

      const formatted = new Intl.NumberFormat("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(parseFloat(detailRows[i].amount));

      const updated = [...detailRows];
      updated[i]["amount"] = formatted;

      setDetailRows(updated);

    }

    setIsEditable(true);
    setIsEditMode(true);

  };

  return (
    <Container fluid className="p-3">
      {/* Header */}
      <Card className="p-3 mb-4">
        <Row className="mb-3">
          <Col md={3}>
            <InputGroup style={{ marginTop: '10px' }}>
              <InputGroup.Text>Voucher No</InputGroup.Text>
              <Form.Control style={{ textAlign: 'right' }} type="text" name="vchr_no"
                className="form-control" value={headerData.vchr_no} disabled />
            </InputGroup>
          </Col>
          <Col md={3}>
            <InputGroup style={{ marginTop: '10px' }}>
              <InputGroup.Text>Voucher Date</InputGroup.Text>
              <Form.Control type="date" name="vchr_date" className="form-control"
                value={headerData.vchr_date} onChange={handleHeaderChange} disabled={!isEditable} />
            </InputGroup>
          </Col>

          <Col md={4}>
            <InputGroup style={{ marginTop: '10px' }}>
              <InputGroup.Text>Section</InputGroup.Text>
            {/* <Form.Label>Section</Form.Label> */}
            <Form.Select
              className="form-select"
              name="sect_id"
              value={headerData.sect_id}
              onChange={handleHeaderChange}
              disabled={isEditMode}
            >
              <option value="">-- Select Section --</option>
              {ddlSections.map(sec => (
                <option key={sec.section_id} value={sec.section_id}>{sec.section_desc}</option>
              ))}
            </Form.Select>
            </InputGroup>
          </Col>

          {/* <Col md={3}>
            <InputGroup style={{ marginTop: '10px' }}>
              <InputGroup.Text>Cost Center</InputGroup.Text>
              <Form.Select name="cc_id" value={headerData.cc_id}
                onChange={handleHeaderChange} disabled={!isEditable} >
                <option value="">-- Select Cost Center -- </option>
                {dropdowns.commonList.filter(c => c.comm_type === 'COSTCENT').map(c => (
                  <option key={c.irn} value={c.irn}>{c.type_desc}</option>
                ))}
              </Form.Select>
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup style={{ marginTop: '10px' }}>
              <InputGroup.Text>Budget</InputGroup.Text>
              <Form.Select
                className="form-select"
                name="bgt_id"
                value={headerData.bgt_id}
                onChange={handleHeaderChange}
                disabled={!isEditable}
              >
                <option value="">-- Select Budget --</option>
                {dropdowns.commonList.filter(c => c.comm_type === 'BUDGET').map(c => (
                  <option key={c.irn} value={c.irn}>{c.type_desc}</option>
                ))}
              </Form.Select>
            </InputGroup>
          </Col> */}

        </Row>

        <Row className="mb-3">

          <Col md={6}>
            {/* <InputGroup style={{marginTop: '10px'}}>
            <InputGroup.Text>Narration</InputGroup.Text>
            <Form.Control 
              type="text"
              name="hdr_narration"
              className="form-control"
              value={headerData.hdr_narration}
              onChange={handleHeaderChange}
              disabled={!isEditable}/>
            </InputGroup> */}
          </Col>
          <Col md={12} className="d-flex justify-content-end">
            <Button style={{height: '40px', marginTop: '10px', width: '100px'}} className="me-2" variant="primary" 
                  disabled={isEditable} onClick={handleNew}>New </Button>
            <Button style={{height: '40px', marginTop: '10px', width: '100px'}} className="me-2" variant="warning"
                   disabled={isEditable} onClick={(e) => (setShowSearchModal(true))}>Edit </Button>
            {showsearchModal && (
              <EditJV_VchrModal
                show={showsearchModal}
                handleClose={() => setShowSearchModal(false)}
                onRowSelect={handleVchrRowSelect}
              />
            )}
            <Button style={{height: '40px', marginTop: '10px', width: '100px'}} className="me-2" variant="secondary" 
                           disabled={!isEditable} onClick={handleClear}>Clear</Button>
            <Button style={{height: '40px', marginTop: '10px', width: '100px'}} className="me-2" variant="success" 
                        disabled={!isEditable} onClick={handleSave}>Save</Button>
          </Col>
        </Row>

      </Card>

      {/* Details Table */}
      <Card className="p-3">
        <div style={{ minHeight: '220px' }} className="table-wrapper">
          <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table">
            <thead>
              <tr>
                <th style={{width: '5%', textAlign: 'center'}}>#</th>
                <th style={{width: '40%', textAlign: 'left'}}>Account/Ledger Name</th>
                <th style={{width: '12%', textAlign: 'right'}}>Amount</th>
                <th style={{width: '7%', textAlign: 'left'}}>Dr/Cr</th>
                <th style={{width: '30%', textAlign: 'left'}}>Narration</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {detailRows.map((row, index) => (
                <tr key={index}>
                  <td style={{ width: "5%", textAlign: 'center' }}>{index + 1}</td>
                  <td>
                    <Select name="acct_code"
                      options={options}
                      value={options.find(option => String(option.value) === String(row.acct_code)) || null}
                      onChange={(selectedOption) => handleAccntChange(index, selectedOption)}
                      isDisabled={!isEditable} placeholder="-- Select Account --"
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    />

                  </td>
                  <td>
                    <input type="text" name="amount" className="form-control text-end"
                      value={row.amount} 
                      onChange={(e) => handleDetailChange(index, e)}
                      onBlur={(e) => handleDtlAmtBlur(index, e)}
                      disabled={!isEditable} min="0" />
                  </td>
                  <td>
                    <select className="form-select" name="drcr" value={row.drcr}
                      onChange={(e) => handleDetailChange(index, e)} disabled={!isEditable} >
                      <option value="DR">Dr</option>
                      <option value="CR">Cr</option>
                    </select>
                  </td>
                  <td>
                    <input
                      type="text"
                      name="narration"
                      className="form-control"
                      value={row.narration}
                      onChange={(e) => handleDetailChange(index, e)}
                      disabled={!isEditable}
                    />
                  </td>
                  <td>
                    {detailRows.length > 1 && (
                      <Button size="sm" variant="danger" onClick={() => removeRow(index)}
                        disabled={!isEditable} >Delete </Button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="d-flex justify-content-between align-items-center mb-3" style={{marginTop: '10px'}}>
          <div className="d-flex gap-2">
            <InputGroup style={{ width: "300px" }}>
              <InputGroup.Text style={{ width: "110px", background: "lightblue", color: "black" }}>Total Dr Amt</InputGroup.Text>
              <input type="text" name="totDrAmt" className="form-control text-end"
                value={totDrAmt} disabled min="0" />
            </InputGroup>
            <InputGroup style={{ width: "300px" }}>
              <InputGroup.Text style={{ width: "110px", background: "lightblue", color: "black" }}>Total Cr Amt</InputGroup.Text>
              <Form.Control type="text" name="totCrAmt" className="form-control text-end"
                value={totCrAmt} disabled min="0" />
            </InputGroup>
            <InputGroup style={{ width: "300px" }}>
              <InputGroup.Text style={{ width: "110px", background: "orange", color: "black" }}>Difference</InputGroup.Text>
              <Form.Control type="text" name="totAmtDiff" className="form-control text-end"
                value={totAmtDiff} disabled min="0" />
            </InputGroup>
          </div>
          <div className="d-flex gap-2">
              <Button variant="primary" onClick={addRow} disabled={!isEditable}> Add Row </Button>
          </div>
        </div>
      </Card>
    </Container>
  );
};

export default FinPaymentVoucher;
